import React, { FC } from "react";

import { motion } from "framer-motion";

import Step1 from "../../../../../../../public/services-step-1.png";
import Step2 from "../../../../../../../public/services-step-2.png";
import Step3 from "../../../../../../../public/services-step-3.png";

const steps = [Step1, Step2, Step3];

type Props = {
  index: number;
  width: number | string;
  height: number | string;
};

const StepMandala: FC<Props> = ({ index, width, height }) => {
  return (
    <div style={{ width, height }}>
      <motion.img
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
        key={steps[index].src}
        src={steps[index].src}
        width={width}
        height={height}
      />
    </div>
  );
};

export default StepMandala;
